export default __webpack_public_path__ + "static/media/nodata.42a2ac22.png";